import IconButton from '@mui/material/IconButton';
import React from 'react';
import { CgSpinner } from 'react-icons/cg';
import { FiDownload } from 'react-icons/fi';
import { toast } from 'react-toastify';

import api from '../../services/apiSgft';
import { TrainingControlAtom } from '../../state/TrainingControl.atom';
import LightTooltip from '../atoms/LightTooltip';

interface TrainingControlDownloadButtonProps {
	filteredData: TrainingControlAtom;
}

export const TrainingControlDownloadButton: React.FC<
	TrainingControlDownloadButtonProps
> = ({ filteredData }) => {
	const [loading, setLoading] = React.useState(false);

	async function download() {
		setLoading(true);
		try {
			const response = await api.get(`/extraction/training-control`, {
				params: {
					employee: filteredData.employee,
					role: filteredData.role,
					rmStatus: filteredData.rmStatus,
					training: filteredData.training,
					presencialCompletionStatus: filteredData.presencialCompletionStatus,
					onlineCompletionStatus: filteredData.onlineCompletionStatus,
					expirationStatus: filteredData.expirationStatus,
					validityStartDate: filteredData.timeRange.startDate,
					validityEndDate: filteredData.timeRange.endDate,
					management: filteredData.management,
					areaCoordinator: filteredData.areaCoordinator,
					pole: filteredData.pole,
					workstation: filteredData.workstation,
					trainingType: filteredData.trainingType,
				},
				responseType: 'blob',
			});
			const url = window.URL.createObjectURL(
				new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				}),
			);
			const link = document.createElement('a');

			link.href = url;
			link.setAttribute('download', 'Controle de Treinamentos - SGFT.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (e) {
			toast.error('Estrutura sem dados', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="cursor-pointer">
			<LightTooltip title="Extrair todos os controles de treinamentos presentes em tela">
				<IconButton onClick={download} disabled={loading}>
					{loading ? (
						<CgSpinner
							size={30}
							color="#c1c1c1"
							className="h-full animate-spin"
						/>
					) : (
						<FiDownload color="grey" fontSize={'1.6rem'} />
					)}
				</IconButton>
			</LightTooltip>
		</div>
	);
};
